export enum CustomBreakpoints {
  SMALL = '(max-width: 849px)',
  HIGH = '(min-width: 850px)',
}

export enum CustomBrokingBreakpoints {
  SMALL = '(max-width: 550px)',
  HIGH = '(min-width: 551px)',
}
